import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'
import * as store from '../store'
// import LoginView from '../views/LoginView.vue'
import * as tools from '../assets/tools'
import * as gTools from '../../../../../global/js/tools'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    meta: {
      title: 'Login'
    },
    // component: component: () => import(/* webpackChunkName: "loginView" */ '../views/LoginView.vue')
    component: () => import(/* webpackChunkName: "loginView" */ '@/views/LoginView.vue')
  },
  {
    path: '/login',
    name: 'login',
    meta: {
      title: 'Login'
    },
    // component: component: component: () => import(/* webpackChunkName: "loginView" */ '../views/LoginView.vue')
    component: () => import(/* webpackChunkName: "loginview" */ '@/views/LoginView.vue')
  },
  {
    path: '/recharge',
    name: 'recharge',
    meta: {
      title: 'Recharge'
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "rechargeview" */ '@/views/RechargeView.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

// check router is login?
router.beforeEach((to: any, from: any, next) => {

  if (to.path === '/login') {
    document.body.className = 'login-skin'
  } else {
    document.body.className = ''
  }
  // get token in Browser
  let token = tools.getTokenBySession() || gTools.getToken();
  // get token in WooliveApp-Webview
  // (window as any).WOOLIVE_ANDROID_INTERACTION = {}
  console.warn('LOGIN', token)
  if (gTools.isInApp()) {
    token = gTools.getToken()
    // target = (to.from)
    if (to.query.from && to.query.from === 'agency') {
      store.commit('isFromAgency', true)
      console.warn(to.query)
    }
    if (token) {
      tools.saveTokenToSession(token)
    }
  } 
  // else {
  //   token = tools.getTokenBySession()
  // }
  if (token) {
    if (to.path === '/recharge') {
      next()
    } else {
      next('/recharge')
    }
  } else {
    if (to.path === '/login') {
      next()
    } else {
      next('/login')
    }
  }
})

const DEFAULT_TITLE = 'WooLive';
router.afterEach((to: any) => {
    // Use next tick to handle router history correctly
    // see: https://github.com/vuejs/vue-router/issues/914#issuecomment-384477609
    document.title = to.meta.title || DEFAULT_TITLE;
});

export default router
